// Clés marketplace ajoutées lors du passage EN-défaut (hors base historique).
export default {
  fr: {
    "filter.allSpecialties": "Toutes spécialités",
  },
  en: {
    "filter.allSpecialties": "All specialties",
  },
  es: {
    "filter.allSpecialties": "Todas las especialidades",
  },
};
